/* There is only one implementation so far,
   but it may come in handy in the future,
   especially for debugging */

/**
 * Stimulus controller identifier has the following format:
 * 'some-controller-name'.
 *
 * The aim of this method is to convert this identifier
 * into a "nice" text string that mimics
 * the name of the Stimulus controller class.
 *
 * Example:
 * 'some-controller-name' -> 'SomeControllerNameController'
 *
 * This conversion is only used to help the developers
 * orient themselves in the DOM.
 */
const convertStimulusControllerIdentifierToClassName = (controller) => {
  let base = controller.context.module.identifier;
  base = base[0].toUpperCase() + base.slice(1).toLowerCase();

  let result = base[0];

  for (let i = 1; i < base.length; i++) {
    const char = base[i];

    if (char === '-' && i + 1 < base.length) {
      result += base[i + 1].toUpperCase();
      i++;
    } else if (char !== '-') {
      result += char;
    }
  }

  return result;
}

const controllerFullName = (controller) => {
  return `${convertStimulusControllerIdentifierToClassName(controller)}Controller`;
}

export default controllerFullName